import { useMutation } from '@tanstack/react-query'
import { apiClient, normalizeApiError } from '../../lib/apiClient'
import Panel from '../../components/cards/Panel'
export default function BrandingUpload() {
  const m = useMutation({
    mutationFn: (d: FormData) => apiClient.post('/admin/branding', d),
  })
  return (
    <Panel title="Branding images">
      <p>Doctor photographs are managed in Admin → Doctors.</p>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          m.mutate(new FormData(e.currentTarget))
        }}
      >
        <label>
          Image type
          <select className="form-select" name="kind">
            <option value="logo">Logo</option>
            <option value="favicon">Favicon</option>
          </select>
        </label>
        <label className="d-block my-3">
          PNG, JPG or WebP, up to 2 MB
          <input
            className="form-control"
            type="file"
            name="file"
            accept=".jpg,.jpeg,.png,.webp"
            required
          />
        </label>
        <button className="btn btn-primary" disabled={m.isPending}>
          Upload
        </button>
        {m.isSuccess && (
          <p role="status">
            Branding saved. Refresh the public portfolio to see it.
          </p>
        )}
        {m.isError && <p role="alert">{normalizeApiError(m.error).message}</p>}
      </form>
    </Panel>
  )
}
